// src/components/InvoiceCard.js — Adds: print label button + scan progress indicator
import React from 'react';

export default function InvoiceCard({ invoice, onPick, onComplete, onPrint, isPicked, scanCount, scanLabels }) {
  const amount = invoice.invoice_value || 0;

  return (
    <div style={{
      backgroundColor: 'white',
      borderRadius: '10px',
      border: '1px solid #e5e7eb',
      padding: '16px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      transition: 'all 0.2s ease',
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      height: '100%',
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
      e.currentTarget.style.transform = 'translateY(-2px)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
      e.currentTarget.style.transform = 'translateY(0)';
    }}>

      {/* Header: Invoice # and Amount */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '8px' }}>
        <div>
          <p style={{ fontSize: '16px', fontWeight: '700', color: '#1f2937', margin: '0' }}>
            {invoice.invoice_number}
          </p>
          <p style={{ fontSize: '12px', color: '#9ca3af', margin: '4px 0 0 0' }}>
            {invoice.invoice_date ? new Date(invoice.invoice_date).toLocaleDateString() : 'N/A'}
          </p>
        </div>
        <div style={{ textAlign: 'right' }}>
          <p style={{ fontSize: '16px', fontWeight: '700', color: '#059669', margin: '0' }}>
            ₹{parseFloat(amount).toFixed(2)}
          </p>
        </div>
      </div>

      {/* Party Name */}
      <div>
        <p style={{ fontSize: '14px', fontWeight: '600', color: '#1f2937', margin: '0 0 6px 0', lineHeight: '1.4' }}>
          {invoice.party_name || 'N/A'}
        </p>
      </div>

      {/* Address */}
      <div>
        <p style={{ fontSize: '12px', color: '#6b7280', margin: '0', lineHeight: '1.4' }}>
          {invoice.address || 'Address not available'}
        </p>
      </div>

      {/* Phone Number */}
      {invoice.phone && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span style={{ fontSize: '14px' }}>📞</span>
          <a href={`tel:${invoice.phone}`} style={{ fontSize: '13px', color: '#2563eb', textDecoration: 'none', fontWeight: '600' }}>
            {invoice.phone}
          </a>
        </div>
      )}

      {/* Scan progress (only shown when in-progress and there's a multi-step flow) */}
      {isPicked && scanLabels && scanLabels.length > 1 && (
        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
          {scanLabels.map((label, i) => {
            const stepNum = i + 1;
            const done = stepNum <= (scanCount || 1);
            return (
              <span key={i} style={{
                fontSize: '10px',
                padding: '3px 8px',
                borderRadius: '999px',
                backgroundColor: done ? '#dcfce7' : '#f3f4f6',
                color: done ? '#166534' : '#9ca3af',
                fontWeight: '600',
              }}>
                {done ? '✓' : stepNum} {label}
              </span>
            );
          })}
        </div>
      )}

      {/* Spacer */}
      <div style={{ flex: 1 }}></div>

      {/* Buttons */}
      {isPicked && onPrint ? (
        <button
          onClick={onPrint}
          style={{
            width: '100%',
            padding: '10px 12px',
            backgroundColor: '#7c3aed',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s',
          }}
          onMouseEnter={(e) => { e.target.style.backgroundColor = '#6d28d9'; e.target.style.transform = 'translateY(-1px)'; }}
          onMouseLeave={(e) => { e.target.style.backgroundColor = '#7c3aed'; e.target.style.transform = 'translateY(0)'; }}
        >
          🖨️ Print Label
        </button>
      ) : (
        <button
          onClick={isPicked ? onComplete : onPick}
          style={{
            width: '100%',
            padding: '10px 12px',
            backgroundColor: isPicked ? '#059669' : '#2563eb',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s',
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = isPicked ? '#047857' : '#1d4ed8';
            e.target.style.transform = 'translateY(-1px)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = isPicked ? '#059669' : '#2563eb';
            e.target.style.transform = 'translateY(0)';
          }}
        >
          {isPicked ? '✓ Complete' : '► Pick Invoice'}
        </button>
      )}
    </div>
  );
}
